import styled from '@emotion/styled'

export const StyleMainContainer = styled.div`
  display: flex;
  gap: 20px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const InfosContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  row-gap: 30px;
  padding-bottom: 70px;
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
`

export const StyleProfileInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  align-items: flex-start;
  color: ${(props: any) => props.theme.colors.text};
  width: 100%;
`

export const StyleLabel = styled.p`
  font-size: 14px;
  letter-spacing: 0.25px;
  line-height: 20px;
`
export const StyleTextContaienr = styled.div`
  padding: 0px 12px;
  display: flex;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.25px;
  border-radius: 6px;
  height: 50px;
  border: 1px solid ${(props: any) => props.theme.colors.borderColor};
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`
export const LeftColumn = styled.div`
  flex: 3;
`

export const RightColumn = styled.div`
  flex: 2;
`

export const NoImageOverlay = styled.div`
  position: absolute;
  inset: 0; /* cover the entire field */
  background-color: gainsboro;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  pointer-events: none; /* don’t block upload clicks */
  z-index: 2;
`
